// Outbound clicks to a product's site: a beacon to /clicks (one per visitor
// per product per day is kept server-side). The link itself is a normal link.
export function bindClicks(root: Document = document): void {
  root.addEventListener('click', (event) => {
    const link = (event.target as Element).closest<HTMLAnchorElement>('a[data-click]')
    if (!link) return
    const body = new Blob([JSON.stringify({ product: link.dataset.click, source: link.dataset.clickSource })], { type: 'application/json' })
    navigator.sendBeacon?.('/clicks', body)
  })
}
